// -------------------------------------------------------------------------------------------------
// 1. Import Components
import "./login.mcss";
import "@bux/input/text/string.mts";
import "@bux/input/text/password.mts";
import "@bux/input/checkbox.mts";
// -------------------------------------------------------------------------------------------------
// 2. Import Code
import { SEC } from "@arlib/lib.mts";
import { Uuid } from "@artyp/lib.mts";
import { copy_view, make_view } from "@bux/document/mod.mts";
import { go_next } from "@bux/singleton/nav_stack.mts";
import { enter_email, enter_password } from "./loginλ.mts";

import BuxInputTextPassword from "@bux/input/text/password.mts";
import BuxInputTextString from "@bux/input/text/string.mts";

// -------------------------------------------------------------------------------------------------
// 3. Find Elements

const $views = SEC(HTMLDivElement, document, "#views");
const $wrapper = SEC(HTMLElement, document, "#wrapper");
const next_uri = $wrapper.dataset["nextUri"] ?? null;

// -------------------------------------------------------------------------------------------------
// 4. Define States

function enter_email_state() {
    const $view = copy_view("view1");
    const $form = SEC(HTMLFormElement, $view, "form");
    const $email = SEC(BuxInputTextString, $view, "[name=email]");

    $form.addEventListener("submit", async (event: Event) => {
        event.preventDefault();
        await submit();
    });

    $views.replaceChildren($view);

    async function submit() {
        $views.replaceChildren(make_view(
            "processing",
            `
            <p>Processing...</p>
        `,
        ));

        const email = $email.value ?? null;
        // Call server
        const output = await enter_email.call({
            email,
        });

        if ("Error" in output) {
            $views.replaceChildren($view);
            $email.set_e(output.Error.message);
            $form.reportValidity();
            return;
        }

        if ("Disabled" in output) {
            $views.replaceChildren($view);
            $email.set_e("Password login is currently disabled for this application.");
            $form.reportValidity();
            return;
        }

        return new EnterPasswordState({ auth_password_uuid: output.Ok.auth_password_uuid });
    }
}

class EnterPasswordState {
    $view = copy_view("view2");
    $view_processing = make_view(
        "processing",
        `
        <p>Processing...</p>
    `,
    );
    $form = SEC(HTMLFormElement, this.$view, "form");
    $password = SEC(BuxInputTextPassword, this.$view, "[name=password]");
    auth_password_uuid: Uuid;

    constructor(trans: { auth_password_uuid: Uuid; }) {
        this.auth_password_uuid = trans.auth_password_uuid;

        this.$form.addEventListener("submit", async (event: Event) => {
            event.preventDefault();
            await this.submit();
        });

        $views.replaceChildren(this.$view);
    }

    async submit() {
        $views.replaceChildren(this.$view_processing);
        const password = this.$password.value ?? null;
        // Call server
        const output = await enter_password.call({
            auth_password_uuid: this.auth_password_uuid,
            password,
            remember_me: false,
            next_uri,
        });

        if ("InputErr" in output) {
            $views.replaceChildren(this.$view);
            const errorMessage = output.InputErr[0].auth_password_uuid ?? output.InputErr[0].password
                ?? "An error occurred";
            this.$password.set_e(errorMessage);
            this.$form.reportValidity();
            return;
        }

        if ("Disabled" in output) {
            $views.replaceChildren(this.$view);
            this.$password.set_e("Password login is currently disabled for this application.");
            this.$form.reportValidity();
            return;
        }

        return complete_state(output.Ok.next_uri);
    }
}

async function complete_state(next_uri: string) {
    go_next(next_uri);
}

enter_email_state();
